<template>
    <b-form-group :invalid-feedback="error" :state="state">
        <stripe-card v-on="listeners" v-bind="attrs" :state="state" @element-change="handleStripeCardElementChange" />
    </b-form-group>
</template>

<script>
    import { convertFromStripeCardType, PAYMENT_CARD_MAPPING } from '../../../constants';
    import StripeCard from '../stripe-card/stripe-card.vue';

    export default {
        name: 'FormStripeCard',
        components: {
            StripeCard,
        },
        props: {
            value: {
                type: String,
            },
            error: {
                type: String,
                default: null,
            },
            validPaymentCardTypes: {
                type: Array,
                default: null,
            },
        },
        computed: {
            state() {
                if (this.error) {
                    return !this.error;
                }
            },
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
        methods: {
            handleStripeCardElementChange(event) {
                if (this.validPaymentCardTypes && this.validPaymentCardTypes.length > 0 && !!event.brand) {
                    const cardType = convertFromStripeCardType(event.brand);
                    if (!this.validPaymentCardTypes.find((ct) => ct.id === cardType)) {
                        const cardTypeText = PAYMENT_CARD_MAPPING[cardType] || 'This';
                        const cardTypesText = this.validPaymentCardTypes.map((ct) => ct.name).join(', ');
                        this.$emit('input', `${cardTypeText} card is not supported. We only support ${cardTypesText}.`);
                    } else if (event.complete) {
                        this.$emit('input', 'OK');
                    } else if (event.error) {
                        this.$emit('input', event.error.message);
                    } else {
                        this.$emit('input', 'Invalid card.');
                    }
                } else {
                    if (event.complete) {
                        this.$emit('input', 'OK');
                    } else if (event.error) {
                        this.$emit('input', event.error.message);
                    } else {
                        this.$emit('input', 'Invalid card.');
                    }
                }

                this.$emit('element-change', event);
            },
        },
    };
</script>
